export const TAX_DEPRECIATION_AMOUNT = 15000;
